import { forwardRef } from 'react';

import * as S from './styled/Radio.styled';

const Radio = (props, ref) => (
	<S.Radio
		ref={ref}
		type="radio"
		className={`${props.error ? 'error' : ''} ${props.className ? props.className : ''}`}
		{...props}
	/>
);

export default forwardRef(Radio);
